import reducer from './reducer';

export { showLoader, hideLoader } from './reducer';

export {
  getLoaderByType,
} from './selectors';

export default reducer;
